var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    'width': _vm.width,
    'height': _vm.height,
    'background': _vm.backgroundColor
  })},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.elementId}})])}
var staticRenderFns = []

export { render, staticRenderFns }